import { Navigate } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import useSongId from 'hooks/useSongId';
import AISongDetailsContainer from './AISongDetailsContainer';
import RegularSongDetailsContainer from './RegularSongDetailsContainer';

const SongDetailsContainer = () => {
  const { error, id, isAIGenerated } = useSongId();

  if (error) {
    return <Navigate to={locations.other.blankPage.pathname} />;
  }

  if (isAIGenerated) {
    return <AISongDetailsContainer id={id} />;
  }

  return <RegularSongDetailsContainer id={id} />;
};

export default SongDetailsContainer;
